import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {applicationStatus} from '../../shared-component/compare/compare.service';
import {LoanService} from '../../shared-component/service/loan/loan.service';

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss']
})
export class StatusComponent implements OnInit {

  public loanId: number;
  public loanDetail: any = {};
  public loanStatus: any = '';
  public applicationStatus = applicationStatus;

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private loanService: LoanService
  ) {
  }

  ngOnInit() {
    this.activeRoute.data.subscribe((res: any) => {
      if (res.loanDetail && Object.keys(res.loanDetail).length) {
        this.loanId = res.loanDetail.id;
        this.loanDetail = res.loanDetail;
        this.loanStatus = res.loanDetail.applicationStatus;
      }
    });
  }

  update() {
    this.loanService.pingLoanDetails(this.loanId).subscribe((res: any) => {
        this.loanDetail = res.data;
        this.loanId = res.data.id;
        this.loanStatus = res.data.applicationStatus;
    });
  }
}
